/**
 * HelpChatPage — /help/chat: the Ask Resida Help conversation at full width, the same AskPanel (and the
 * same conversation) as the panel's Ask tab.
 */

import { Link } from 'react-router-dom';
import { ArrowLeft, History, Plus } from 'lucide-react';
import { Button } from '../components/ui/button';
import { PageHeader } from '../components/layout/index';
import { AskPanel } from '../components/help/AskPanel';
import { useHelp } from '../components/help/HelpProvider';

export function HelpChatPage() {
  const { chat, chatDisabled, historyOpen, setHistoryOpen } = useHelp();

  return (
    <div className="mx-auto max-w-3xl px-[var(--page-padding-x)] pb-6" data-testid="help-chat-page">
      <Link
        to="/help"
        data-testid="help-chat-back"
        className="inline-flex min-h-[44px] items-center gap-1 text-sm text-muted-foreground hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
      >
        <ArrowLeft className="h-4 w-4" aria-hidden="true" />
        Help center
      </Link>
      <PageHeader
        title="Ask Resida Help"
        action={
          chatDisabled ? undefined : (
            <div className="flex items-center gap-2">
              <Button
                type="button"
                variant="outline"
                onClick={() => setHistoryOpen(!historyOpen)}
                aria-pressed={historyOpen}
                data-testid="help-page-history"
              >
                <History aria-hidden="true" />
                <span className="hidden sm:inline">Conversations</span>
                <span className="sr-only sm:hidden">Conversations</span>
              </Button>
              <Button
                type="button"
                variant="outline"
                onClick={() => {
                  chat.newConversation();
                  setHistoryOpen(false);
                }}
                data-testid="help-page-new-conversation"
              >
                <Plus aria-hidden="true" />
                <span className="hidden sm:inline">New conversation</span>
                <span className="sr-only sm:hidden">New conversation</span>
              </Button>
            </div>
          )
        }
      />
      <div className="flex h-[calc(100dvh-var(--topbar-height)-var(--bottom-tab-height)-9rem)] min-h-[420px] flex-col overflow-hidden rounded-xl border border-border bg-card md:h-[calc(100dvh-14rem)]">
        <AskPanel variant="page" />
      </div>
    </div>
  );
}
